import { render, staticRenderFns } from "./VerticalNav.vue?vue&type=template&id=51cd5ba6"
import script from "./VerticalNav.vue?vue&type=script&lang=js"
export * from "./VerticalNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports